import React from 'react';
import styled, { keyframes } from 'styled-components';

import Box from 'components/Box';
import { Color, colors } from 'theme';

const aFill = keyframes`
  from {
    transform: scaleX(0.001);
  }

  to {
    transform: scaleX(1);
  }
`;
const Amount = styled(Box)<{ $duration: number; $delay: number }>`
  transform: scaleX(0.001);
  transform-origin: left center;
  animation: ${aFill} ${(props) => props.$duration}s ${(props) => props.$delay}s
    forwards;
`;
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
export default ({
  total,
  current,
  color = 'marigold',
  duration = 1,
  delay = 0.33,
}: {
  total: number;
  current: number;
  color?: Color;
  duration?: number;
  delay?: number;
}) => (
  <Box overflow="hidden" borderRadius="3px" bg={colors.aluminum}>
    <Box width={`${(current / total) * 100}%`}>
      <Amount bg={color} height="6px" $delay={delay} $duration={duration} />
    </Box>
  </Box>
);
